import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=19ed423a&scoped=true&lang=pug&"
import script from "./CallsList.vue?vue&type=script&lang=js&"
export * from "./CallsList.vue?vue&type=script&lang=js&"
import style0 from "./CallsList.vue?vue&type=style&index=0&id=19ed423a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed423a",
  null
  
)

export default component.exports